export default __webpack_public_path__ + "static/media/Alex_Headshot.e53dd807.jpeg";